import React from "react";
import { Flex, Spinner } from "@chakra-ui/react";
// Legacy JS components — cast to any to avoid strict-mode prop type errors on unmigrated code
import { FormattedInput as FormattedInputLegacy } from "components/FormInputs/FormattedInput";
import { Heading } from "components/Heading";

const FormattedInput = FormattedInputLegacy as React.ComponentType<any>;
import { useState } from "react";
import { RfxDocumentManager } from "newui/features/Rfx/Documents";

interface SelectOption {
  label: string;
  value: number;
}

interface DocumentationProps {
  documentCategories?: SelectOption[];
  isTemplate?: boolean;
  rfxOrRfxTemplateId: number;
  subTitlePage?: string;
  titlePage?: string;
}

const Documentation = ({
  rfxOrRfxTemplateId,
  titlePage,
  subTitlePage,
  documentCategories = [],
  isTemplate = false,
}: DocumentationProps) => {
  const isLoading = false;
  const [selectedCategory, setSelectedCategory] = useState<number>(
    documentCategories?.[0]?.value ?? 1
  );

  return (
    <div className="flex w-full flex-col">
      <div id="subheader-page" className="py-8">
        <div
          id="subheader-page-title"
          className="text-xl font-semibold text-primary-900"
        >
          <Heading fontSize="36px" color="#003CE9">
            {" "}
            {titlePage}
          </Heading>
        </div>
        <div
          id="subheader-page-subtitle"
          className="mt-1 font-roboto text-sm text-tertiary-600"
        >
          {subTitlePage}
        </div>
      </div>
      <div id="project-detail-content" className="relative h-full min-h-[60vh]">
        {!isLoading ? (
          <>
            <Flex>
              <FormattedInput
                label="Documentation Description (Optional)"
                name="documentation_description"
                characterLimit={1500}
                rfq
                className="w-full"
                placeholder="E.g. Tender Documents - Information for Tenderers"
                subTitle="Summarise what documents are uploaded as part of this request."
              />
            </Flex>
            <Flex gap={8} marginBottom={20}>
              <RfxDocumentManager isTemplate={isTemplate} rfqId={rfxOrRfxTemplateId} hideRevision />
            </Flex>
          </>
        ) : (
          <Spinner
            className="absolute left-1/2 top-[30vh] -translate-x-1/2"
            size="xl"
          />
        )}
      </div>
    </div>
  );
};

export default Documentation;
